import currencyAPI from '../../api/Currency'
import * as types from '../mutation-types'

// STATE
const state = {
    CurrencyOptions: [],
    CurrencySymbol: ""
}

// GETTERS
const getters = {
    CurrencyOptions: state => state.CurrencyOptions,
    CurrencySymbol: state => state.CurrencySymbol
}

// ACTIONS
const actions = {
    getCurrencyOptions({ commit }) {
        return new Promise((resolve, reject) => {
            currencyAPI.getCurrencyOptions(currencyOptions => {
                commit(types.RECEIVE_CURRENCY_OPTIONS, { currencyOptions })
                resolve()
            })
        })
    },
    getCurrencySymbol({ commit }, currencyCode) {
        return new Promise((resolve, reject) => {
            currencyAPI.getCurrencySymbol(currencySymbol => {
                commit(types.RECEIVE_CURRENCY_SYMBOL, { currencySymbol })
                resolve()
            }, currencyCode)
        })
    }
}

// MUTATIONS
const mutations = {
    [types.RECEIVE_CURRENCY_OPTIONS] (state, { currencyOptions }) {
        state.CurrencyOptions = currencyOptions
    },
    [types.RECEIVE_CURRENCY_SYMBOL] (state, { currencySymbol }) {
        state.CurrencySymbol = currencySymbol
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}
  


// WEBPACK FOOTER //
// ./src/store/modules/Currency.js